import {siteListContent} from '../maps/siteNames';

import './Breadcrumb.css'

export function NavBreadcrumb(props) {
  if (props?.getActiveSite())
    return siteTrail(props)
  if (props?.breadCrumb())
    return bcList(bcRender (props.breadCrumb(), 0))
  
  return bcList(bcRender('Site List', 0))
}

function bcList (children, start) {
  return (
  <ul className='bc-ol' key={"bc-base"+start}>
    {children}
  </ul>)
}

function siteTrail(props) {
  return (
    bcList([siteBase(props), bcRender (props.breadCrumb(), 1)], 0)
  )
}
function siteBase(props) {
  const content = siteListContent(props.getActiveSite()) 
  return (
    <li className='bc-sname' key='bs-site'>
      <div className='bc-sname' key='bc-sname'>{content[0]}</div>
      <div className='bc-sac' key='bc-sac'>{content[1]}{content[2]}</div>
    </li>
  )
}

function bcRender (bc, pos) {
  if (Array.isArray(bc)) {
    return bc.map((item, index) => crumbItem(item, index+pos))
  }
  return crumbItem (displayView (bc), pos)
}
function displayView (view) {
  const disp = {'overview':'Site Overview', 'config': 'Configuration', 
      'measure': 'Meter Config', 'metering': 'Readings',
      'netstat':'Troubleshooting', 'commission': 'Uncommissioned',
      'netmap': 'Network Map', 'alertset': 'Alert Emails'}
  return {display: disp[view] ?? 'Site List'}
}
function crumbItem (item, index) {
  const cName = item?.click ? 'bc-link' : 'bc-li navbar-text'
  const click = item?.click ?? null 
  return (
    [index > 0 ? divider(): null,
     <li className={cName} onClick={click} key={'bc'+index}>{item?.display}</li>] 
  )
}
function divider() {
  return <li className='bc-ls navbar-text' key="chevron">&#10095;</li>
}
